import React from "react";
import ArticlesExplorer from "../../../components/pageSection/ArticlesExplorer";
import { useOutletContext } from "react-router-dom";

const SignalsArticles: React.FC = () => {
  const { signalId, userId } = useOutletContext<{
    signalId: string;
    userId: string;
  }>();
  console.log("Signal:", signalId);
  console.log("User:", userId);
  if (!userId || !signalId) {
    return <div>Error: Missing userId or signalId</div>;
  }

  return <ArticlesExplorer userId={userId} signalId={signalId} />;
};

export default SignalsArticles;
